import { render, staticRenderFns } from "./AdvancePricingPage.vue?vue&type=template&id=37410127&"
import script from "./AdvancePricingPage.vue?vue&type=script&lang=js&"
export * from "./AdvancePricingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports